import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../components/DataTable';
import { useAuth } from '../../context/AuthContext';
const GenericSettingsPage = ({ tableName, title, columns, apiPath, }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const fetchData = async () => {
        setIsLoading(true);
        setError('');
        try {
            const response = await fetch(`/api/pricing/${apiPath}`, {
                credentials: 'include',
            });
            if (response.status === 401) {
                navigate('/login');
                return;
            }
            const result = await response.json();
            setData(result.data || []);
        }
        catch (err) {
            setError(err.message || 'Failed to load data');
        }
        finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [apiPath]);
    const handleAdd = async (newRow) => {
        try {
            const response = await fetch(`/api/pricing/${apiPath}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(newRow),
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to add record');
            }
            await fetchData();
        }
        catch (err) {
            alert(err.message);
            throw err;
        }
    };
    const handleUpdate = async (id, updatedRow) => {
        try {
            const response = await fetch(`/api/pricing/${apiPath}/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(updatedRow),
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to update record');
            }
            await fetchData();
        }
        catch (err) {
            alert(err.message);
            throw err;
        }
    };
    const handleDelete = async (id) => {
        try {
            const response = await fetch(`/api/pricing/${apiPath}/${id}`, {
                method: 'DELETE',
                credentials: 'include',
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to delete record');
            }
            await fetchData();
        }
        catch (err) {
            alert(err.message);
            throw err;
        }
    };
    return (_jsxs("div", { className: "min-h-screen bg-gradient-to-br from-primary-50 via-white to-accent-50", children: [_jsx("nav", { className: "bg-white shadow-sm border-b border-secondary-200", children: _jsx("div", { className: "container-custom py-4", children: _jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { className: "flex items-center space-x-4", children: [_jsxs("button", { onClick: () => navigate('/dashboard'), className: "flex items-center space-x-2 text-secondary-600 hover:text-secondary-900", children: [_jsx("div", { className: "w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center", children: _jsx("span", { className: "text-white font-bold text-xl", children: "GD" }) }), _jsx("span", { className: "text-xl font-bold text-secondary-900", children: "Garage Door Intelligence" })] }), _jsx("span", { className: "text-secondary-300", children: "|" }), _jsx("h1", { className: "text-xl font-bold text-secondary-900", children: title })] }), _jsx("button", { onClick: logout, className: "btn btn-outline text-sm py-2", children: "Logout" })] }) }) }), _jsx("main", { className: "container-custom py-8", children: _jsxs("div", { className: "card", children: [error && (_jsx("div", { className: "mb-4 p-3 bg-error-50 border border-error-200 text-error-700 rounded-lg text-sm", children: error })), _jsx(DataTable, { columns: columns, data: data, onAdd: handleAdd, onUpdate: handleUpdate, onDelete: handleDelete, isLoading: isLoading, emptyMessage: `No ${title.toLowerCase()} found. Click "Add New" to create one.` })] }) })] }));
};
export default GenericSettingsPage;
